// Runtime env config: checks window._env_ (injected by Docker entrypoint)
// first, then falls back to process.env (baked in at build time by CRA).
export function getEnv(key) {
    const runtime = window._env_?.[key];
    if (runtime !== undefined && runtime !== '') return runtime;
    return process.env[key];
}
